import { render, staticRenderFns } from "./DetailIndex.vue?vue&type=template&id=6096e893&scoped=true&name=detailIndex&"
import script from "./DetailIndex.vue?vue&type=script&lang=js&"
export * from "./DetailIndex.vue?vue&type=script&lang=js&"
import style0 from "./DetailIndex.vue?vue&type=style&index=0&id=6096e893&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6096e893",
  null
  
)

export default component.exports